import {
  buildNormalizedDay,
  buildNormalizedPilotBlueprint,
  localizedGenderNode,
} from "./referenceNormalizerPilotUtils";

/** Required substring for scripts/validate_dna_blueprints.mjs (runtime writing steps). */
export const DNA_VALIDATE_WRITING_PHRASE = "אני שואל/ת את עצמי בשקט";

const days = [
  {
    dayNumber: 1,
    emotionalStage: "pause",
    title: "Identificar la Voz (Sin Identificarme con Ella)",
    opening: localizedGenderNode(
      [
      "Hoy dejo de llamarlo “yo”. Es una voz — y es cruel."
    ],
      [
      "Hoy dejo de llamarlo “yo”. Es una voz — y es cruel."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo conmigo.",
      "Una respiración lenta.",
      "En mi interior: “Esta es una voz interna — no una verdad absoluta.”"
    ],
      [
      "Me detengo conmigo.",
      "Una respiración lenta.",
      "En mi interior: “Esta es una voz interna — no una verdad absoluta.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. ¿Qué frase cruel apareció hoy?\n[Escribe aquí]",
      "2. ¿En qué tono se dice? (enojado / despectivo / humillante)\n[Escribe aquí]",
      "3. ¿Cuándo esta voz es más fuerte?\n[Escribe aquí]"
    ],
      [
      "1. ¿Qué frase cruel apareció hoy?\n[Escribe aquí]",
      "2. ¿En qué tono se dice? (enojado / despectivo / humillante)\n[Escribe aquí]",
      "3. ¿Cuándo esta voz es más fuerte?\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "Reconocer la voz ya es el primer paso hacia la libertad."
    ],
      [
      "Cierre",
      "Reconocer la voz ya es el primer paso hacia la libertad."
    ]
    ),
    action: localizedGenderNode(
      "Una vez hoy: “Esta es la voz crítica. No soy yo.”",
      "Una vez hoy: “Esta es la voz crítica. No soy yo.”"
    ),
  },
  {
    dayNumber: 2,
    emotionalStage: "pain",
    title: "Qué Intenta Hacer Esta Voz por Mí",
    opening: localizedGenderNode(
      [
      "Hoy reviso: incluso la crítica cruel intenta proteger."
    ],
      [
      "Hoy reviso: incluso la crítica cruel intenta proteger."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo conmigo.",
      "Una respiración."
    ],
      [
      "Me detengo conmigo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. ¿Qué dice la voz que pasará si no soy duro/a conmigo?\n[Escribe aquí]",
      "2. ¿De qué intenta protegerme? (fracaso / rechazo / vergüenza)\n[Escribe aquí]",
      "3. ¿Qué forma menos violenta podría protegerme?\n[Escribe aquí]"
    ],
      [
      "1. ¿Qué dice la voz que pasará si no soy duro/a conmigo?\n[Escribe aquí]",
      "2. ¿De qué intenta protegerme? (fracaso / rechazo / vergüenza)\n[Escribe aquí]",
      "3. ¿Qué forma menos violenta podría protegerme?\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "La intención puede ser protección — el método daña."
    ],
      [
      "Cierre",
      "La intención puede ser protección — el método daña."
    ]
    ),
    action: localizedGenderNode(
      "Digo: “Entiendo el miedo. No la violencia.”",
      "Digo: “Entiendo el miedo. No la violencia.”"
    ),
  },
  {
    dayNumber: 3,
    emotionalStage: "pain",
    title: "Responsabilidad vs. Castigo",
    opening: localizedGenderNode(
      [
      "Hoy separo aprender de destruirme."
    ],
      [
      "Hoy separo aprender de destruirme."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo conmigo.",
      "Una respiración."
    ],
      [
      "Me detengo conmigo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. ¿Por qué me culpo una y otra vez?\n[Escribe aquí]",
      "2. ¿Qué parte sí es mi responsabilidad — y cuál no?\n[Escribe aquí]",
      "3. ¿Cómo suena la responsabilidad sin humillación?\n[Escribe aquí]"
    ],
      [
      "1. ¿Por qué me culpo una y otra vez?\n[Escribe aquí]",
      "2. ¿Qué parte sí es mi responsabilidad — y cuál no?\n[Escribe aquí]",
      "3. ¿Cómo suena la responsabilidad sin humillación?\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "La responsabilidad construye. El castigo destruye."
    ],
      [
      "Cierre",
      "La responsabilidad construye. El castigo destruye."
    ]
    ),
    action: localizedGenderNode(
      "Cuando surge la culpa — reformulo sin insulto.",
      "Cuando surge la culpa — reformulo sin insulto."
    ),
  },
  {
    dayNumber: 4,
    emotionalStage: "pattern",
    title: "Comparación como Crítica Encubierta",
    opening: localizedGenderNode(
      [
      "Hoy veo cómo la comparación se vuelve juicio."
    ],
      [
      "Hoy veo cómo la comparación se vuelve juicio."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo conmigo.",
      "Una respiración."
    ],
      [
      "Me detengo conmigo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. ¿Con quién me comparo cuando me juzgo?\n[Escribe aquí]",
      "2. ¿Qué siempre me falta en esa comparación?\n[Escribe aquí]",
      "3. ¿Qué verdad sobre mí no entra en esa comparación?\n[Escribe aquí]"
    ],
      [
      "1. ¿Con quién me comparo cuando me juzgo?\n[Escribe aquí]",
      "2. ¿Qué siempre me falta en esa comparación?\n[Escribe aquí]",
      "3. ¿Qué verdad sobre mí no entra en esa comparación?\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "La comparación no refleja verdad — intensifica el dolor."
    ],
      [
      "Cierre",
      "La comparación no refleja verdad — intensifica el dolor."
    ]
    ),
    action: localizedGenderNode(
      "Una vez hoy: “Salgo de la comparación.”",
      "Una vez hoy: “Salgo de la comparación.”"
    ),
  },
  {
    dayNumber: 5,
    emotionalStage: "pattern",
    title: "La Vergüenza Debajo de la Crítica",
    opening: localizedGenderNode(
      [
      "Hoy toco la vergüenza sin huir."
    ],
      [
      "Hoy toco la vergüenza sin huir."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo conmigo.",
      "Una respiración."
    ],
      [
      "Me detengo conmigo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. ¿De qué me avergüenzo en mí?\n[Escribe aquí]",
      "2. ¿Qué temo que otros vean?\n[Escribe aquí]",
      "3. ¿Qué humanidad hay en este lugar?\n[Escribe aquí]"
    ],
      [
      "1. ¿De qué me avergüenzo en mí?\n[Escribe aquí]",
      "2. ¿Qué temo que otros vean?\n[Escribe aquí]",
      "3. ¿Qué humanidad hay en este lugar?\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "La vergüenza señala una herida — no un defecto."
    ],
      [
      "Cierre",
      "La vergüenza señala una herida — no un defecto."
    ]
    ),
    action: localizedGenderNode(
      "Una frase de humanidad hacia mí.",
      "Una frase de humanidad hacia mí."
    ),
  },
  {
    dayNumber: 6,
    emotionalStage: "fear",
    title: "Cómo Me Hablo Cuando Me Equivoco",
    opening: localizedGenderNode(
      [
      "Hoy observo mi lenguaje en el error."
    ],
      [
      "Hoy observo mi lenguaje en el error."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo conmigo.",
      "Una respiración."
    ],
      [
      "Me detengo conmigo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. ¿Qué me digo cuando cometo un error?\n[Escribe aquí]",
      "2. ¿Cómo afecta a mi cuerpo?\n[Escribe aquí]",
      "3. ¿Cómo hablaría a un niño en la misma situación?\n[Escribe aquí]"
    ],
      [
      "1. ¿Qué me digo cuando cometo un error?\n[Escribe aquí]",
      "2. ¿Cómo afecta a mi cuerpo?\n[Escribe aquí]",
      "3. ¿Cómo hablaría a un niño en la misma situación?\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "Los errores no requieren violencia."
    ],
      [
      "Cierre",
      "Los errores no requieren violencia."
    ]
    ),
    action: localizedGenderNode(
      "Elijo una frase reparadora en lugar de humillación.",
      "Elijo una frase reparadora en lugar de humillación."
    ),
  },
  {
    dayNumber: 7,
    emotionalStage: "need",
    title: "Experimento: Un Día con Menos Juicio",
    opening: localizedGenderNode(
      [
      "Hoy experimento reducir el juicio — no eliminarlo."
    ],
      [
      "Hoy experimento reducir el juicio — no eliminarlo."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo conmigo.",
      "Una respiración."
    ],
      [
      "Me detengo conmigo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. ¿En qué momentos el juicio aparece más rápido?\n[Escribe aquí]",
      "2. ¿Qué formulación más suave podría reemplazarlo?\n[Escribe aquí]",
      "3. ¿Qué quiero probar hoy?\n[Escribe aquí]"
    ],
      [
      "1. ¿En qué momentos el juicio aparece más rápido?\n[Escribe aquí]",
      "2. ¿Qué formulación más suave podría reemplazarlo?\n[Escribe aquí]",
      "3. ¿Qué quiero probar hoy?\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "Es un experimento, no un examen."
    ],
      [
      "Cierre",
      "Es un experimento, no un examen."
    ]
    ),
    action: localizedGenderNode(
      "Una vez hoy — suavidad en lugar de crueldad.",
      "Una vez hoy — suavidad en lugar de crueldad."
    ),
  },
  {
    dayNumber: 8,
    emotionalStage: "softening",
    title: "Permitir la Imperfección (ACT)",
    opening: localizedGenderNode(
      [
      "Hoy me permito ser imperfecto/a por un minuto."
    ],
      [
      "Hoy me permito ser imperfecto/a por un minuto."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo conmigo.",
      "Una respiración."
    ],
      [
      "Me detengo conmigo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. ¿Qué imperfección activa más mi crítica?\n[Escribe aquí]",
      "2. Un minuto: la dejo estar.\n¿Qué ocurrió?\n[Escribe aquí]",
      "3. ¿Qué aprendí de la sensación?\n[Escribe aquí]"
    ],
      [
      "1. ¿Qué imperfección activa más mi crítica?\n[Escribe aquí]",
      "2. Un minuto: la dejo estar.\n¿Qué ocurrió?\n[Escribe aquí]",
      "3. ¿Qué aprendí de la sensación?\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "La imperfección no me destruye."
    ],
      [
      "Cierre",
      "La imperfección no me destruye."
    ]
    ),
    action: localizedGenderNode(
      "Un minuto basta.",
      "Un minuto basta."
    ),
  },
  {
    dayNumber: 9,
    emotionalStage: "softening",
    title: "Quién Soy Sin Esta Voz",
    opening: localizedGenderNode(
      [
      "Hoy recuerdo quién soy debajo de la crítica."
    ],
      [
      "Hoy recuerdo quién soy debajo de la crítica."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo conmigo.",
      "Una respiración."
    ],
      [
      "Me detengo conmigo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. ¿Quién era antes de que esta voz dominara?\n[Escribe aquí]",
      "2. ¿Qué parte de mí se fue apagando?\n[Escribe aquí]",
      "3. ¿Qué extraño de mí?\n[Escribe aquí]"
    ],
      [
      "1. ¿Quién era antes de que esta voz dominara?\n[Escribe aquí]",
      "2. ¿Qué parte de mí se fue apagando?\n[Escribe aquí]",
      "3. ¿Qué extraño de mí?\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "No soy la voz. Soy la persona debajo."
    ],
      [
      "Cierre",
      "No soy la voz. Soy la persona debajo."
    ]
    ),
    action: localizedGenderNode(
      "Una acción que me reconecte conmigo.",
      "Una acción que me reconecte conmigo."
    ),
  },
  {
    dayNumber: 10,
    emotionalStage: "perspective",
    title: "Compasión Sin Renunciar al Crecimiento",
    opening: localizedGenderNode(
      [
      "Hoy entiendo que la compasión no anula el crecimiento."
    ],
      [
      "Hoy entiendo que la compasión no anula el crecimiento."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo conmigo.",
      "Una respiración."
    ],
      [
      "Me detengo conmigo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. ¿Qué temo si soy amable conmigo?\n[Escribe aquí]",
      "2. ¿Qué crecimiento es posible con compasión?\n[Escribe aquí]",
      "3. ¿Qué frase suave puedo adoptar?\n[Escribe aquí]"
    ],
      [
      "1. ¿Qué temo si soy amable conmigo?\n[Escribe aquí]",
      "2. ¿Qué crecimiento es posible con compasión?\n[Escribe aquí]",
      "3. ¿Qué frase suave puedo adoptar?\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "La compasión es terreno fértil para crecer."
    ],
      [
      "Cierre",
      "La compasión es terreno fértil para crecer."
    ]
    ),
    action: localizedGenderNode(
      "Mano en el cuerpo + la frase suave.",
      "Mano en el cuerpo + la frase suave."
    ),
  },
  {
    dayNumber: 11,
    emotionalStage: "strength",
    title: "Poner un Límite a la Voz Crítica",
    opening: localizedGenderNode(
      [
      "Hoy pongo un límite interno."
    ],
      [
      "Hoy pongo un límite interno."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo conmigo.",
      "Una respiración."
    ],
      [
      "Me detengo conmigo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. ¿Qué frase ya no estoy dispuesto/a a escuchar?\n[Escribe aquí]",
      "2. ¿Cómo suena un límite interno?\n[Escribe aquí]",
      "3. ¿Qué temo si pongo este límite?\n[Escribe aquí]"
    ],
      [
      "1. ¿Qué frase ya no estoy dispuesto/a a escuchar?\n[Escribe aquí]",
      "2. ¿Cómo suena un límite interno?\n[Escribe aquí]",
      "3. ¿Qué temo si pongo este límite?\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "Incluso las voces internas tienen límites."
    ],
      [
      "Cierre",
      "Incluso las voces internas tienen límites."
    ]
    ),
    action: localizedGenderNode(
      "Detengo una frase a mitad.",
      "Detengo una frase a mitad."
    ),
  },
  {
    dayNumber: 12,
    emotionalStage: "release",
    title: "Cambiar el Tono, No Borrar la Historia",
    opening: localizedGenderNode(
      [
      "Hoy cambio el tono — no el pasado."
    ],
      [
      "Hoy cambio el tono — no el pasado."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo conmigo.",
      "Una respiración."
    ],
      [
      "Me detengo conmigo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. ¿Qué historia me cuento?\n[Escribe aquí]",
      "2. ¿Cómo suena la misma historia con un tono humano?\n[Escribe aquí]",
      "3. ¿Qué tono elijo esta semana?\n[Escribe aquí]"
    ],
      [
      "1. ¿Qué historia me cuento?\n[Escribe aquí]",
      "2. ¿Cómo suena la misma historia con un tono humano?\n[Escribe aquí]",
      "3. ¿Qué tono elijo esta semana?\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "El tono define la experiencia."
    ],
      [
      "Cierre",
      "El tono define la experiencia."
    ]
    ),
    action: localizedGenderNode(
      "Una vez hoy — solo cambio de tono.",
      "Una vez hoy — solo cambio de tono."
    ),
  },
  {
    dayNumber: 13,
    emotionalStage: "choice",
    title: "Elegir una Nueva Voz Líder",
    opening: localizedGenderNode(
      [
      "Hoy elijo qué voz me guía."
    ],
      [
      "Hoy elijo qué voz me guía."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo conmigo.",
      "Una respiración."
    ],
      [
      "Me detengo conmigo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. ¿Qué valor quiero que exprese mi voz? (respeto / verdad / suavidad)\n[Escribe aquí]",
      "2. ¿Cómo suena esa voz?\n[Escribe aquí]",
      "3. ¿Qué me prometo en días difíciles?\n[Escribe aquí]"
    ],
      [
      "1. ¿Qué valor quiero que exprese mi voz? (respeto / verdad / suavidad)\n[Escribe aquí]",
      "2. ¿Cómo suena esa voz?\n[Escribe aquí]",
      "3. ¿Qué me prometo en días difíciles?\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "No silencio una voz — cambio el liderazgo."
    ],
      [
      "Cierre",
      "No silencio una voz — cambio el liderazgo."
    ]
    ),
    action: localizedGenderNode(
      "Escribo una frase guía y la guardo.",
      "Escribo una frase guía y la guardo."
    ),
  },
  {
    dayNumber: 14,
    emotionalStage: "continuation",
    title: "Cierre Suave",
    opening: localizedGenderNode(
      [
      "Hoy cierro un camino — no una guerra."
    ],
      [
      "Hoy cierro un camino — no una guerra."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo conmigo.",
      "Una respiración."
    ],
      [
      "Me detengo conmigo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. ¿Qué cambió en mi relación con la crítica?\n[Escribe aquí]",
      "2. ¿Qué comprendo ahora sobre mí?\n[Escribe aquí]",
      "3. Frase de regreso para días difíciles:\n[Escribe aquí]"
    ],
      [
      "1. ¿Qué cambió en mi relación con la crítica?\n[Escribe aquí]",
      "2. ¿Qué comprendo ahora sobre mí?\n[Escribe aquí]",
      "3. Frase de regreso para días difíciles:\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre final",
      "Sigo aprendiendo.",
      "Pero ya no estoy en mi contra.",
      "Y eso es un cambio profundo."
    ],
      [
      "Cierre final",
      "Sigo aprendiendo.",
      "Pero ya no estoy en mi contra.",
      "Y eso es un cambio profundo."
    ]
    ),
    action: localizedGenderNode(
      "Una acción que simbolice elegirme.",
      "Una acción que simbolice elegirme."
    ),
  },
].map(buildNormalizedDay);

export const harshSelfCriticismBlueprintEs = buildNormalizedPilotBlueprint({
  id: "harsh_self_criticism_14d",
  version: "tri_locale_emit_es_v1",
  durationDays: 14,
  problemKey: "harsh_self_criticism",
  category: "general",
  journeyName: {
    he: "שיפוט עצמי אכזרי / ביקורת עצמית אכזרית",
    en: "Harsh Self-Judgment / Cruel Self-Criticism",
    es: "Juicio Interno Cruel / Crítica Interior Severa",
  },
  days,
});

export default harshSelfCriticismBlueprintEs;
